<template>
  <div
      v-if="oldClasses.includes(energyClass)"
      class="relative text-base bg-green-300 text-white no-underline inline-block leading-none font-bold py-2 px-3 mr-4"
      data-tag-name="energy rating icon">
    {{ energyClass }}
    <span class="sr-only">{{ __("Energiamärgis") }}</span>
    <span
        class="w-0 h-0 absolute top-0 -right-4 inline-block border-t-[16px] border-t-transparent border-l-[16px] border-l-green-300 border-b-[16px] border-b-transparent"
        aria-hidden="true"
    >
  </span>
  </div>
  <template v-else>
    <EnergyLabelASvg v-if="['A', 'A+', 'A++', 'A+++'].includes(energyClass)"/>
    <EnergyLabelBSvg v-else-if="energyClass === 'B'"/>
    <EnergyLabelCSvg v-else-if="energyClass === 'C'"/>
    <EnergyLabelDSvg v-else-if="energyClass === 'D'"/>
    <EnergyLabelESvg v-else-if="energyClass === 'E'"/>
    <EnergyLabelFSvg v-else-if="energyClass === 'F'"/>
    <EnergyLabelGSvg v-else-if="energyClass === 'G'"/>
  </template>
</template>
<script setup>
import {__} from "../utils";
import EnergyLabelASvg from "../../images/energy-labels/energy-label-a.svg";
import EnergyLabelBSvg from "../../images/energy-labels/energy-label-b.svg";
import EnergyLabelCSvg from "../../images/energy-labels/energy-label-c.svg";
import EnergyLabelDSvg from "../../images/energy-labels/energy-label-d.svg";
import EnergyLabelESvg from "../../images/energy-labels/energy-label-e.svg";
import EnergyLabelFSvg from "../../images/energy-labels/energy-label-f.svg";
import EnergyLabelGSvg from "../../images/energy-labels/energy-label-g.svg";

defineProps({
  energyClass: {
    type: String,
    required: true
  },
  productClass: {
    type: String,
    required: true
  }
});
const oldClasses = ["CR", "DR", "HOOD", "OVE"];
</script>